import { Component, OnInit, Inject, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/platform-browser';

import { Errors, LocalService, UserService, ProfileService } from '../../core';
import { compareValidator } from '../../shared';
import { CONSTANTS } from '../../config/constants';

@Component({
  selector: 'app-tax-info',
  templateUrl: './tax-info.component.html',
  styleUrls: ['./tax-info.component.scss']
})

export class TaxInfoComponent implements OnInit, AfterViewInit {

  validations = CONSTANTS.validationMessages.formT4;
  errors: Errors = { errors: {} };
  userData: any;
  taxForm!: FormGroup;
  signedOnDate = new Date().toISOString();
  signedOnString!: string;
  states = CONSTANTS.canadaStates;
  taxId: any;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    private profileService: ProfileService,
    @Inject(DOCUMENT) private document: Document
  ) { }

  ngOnInit() {
    // this.checkTokenExpiry();
    this.getAllRoles();
    this.userData = LocalService.get('userProfile');
    this.taxForm = this.fb.group({
      'firstName': ['', [Validators.required, Validators.pattern(CONSTANTS.regex.alpha)]],
      'middleName': ['', [Validators.pattern(CONSTANTS.regex.alpha)]],
      'lastName': ['', [Validators.required, Validators.pattern(CONSTANTS.regex.alpha)]],
      'exemptPayeeCode': ['', [Validators.pattern(CONSTANTS.regex.numeric)]],
      'address': ['', [Validators.required, Validators.maxLength(200)]],
      'city': ['', [Validators.required, Validators.maxLength(50), Validators.pattern(CONSTANTS.regex.alpha)]],
      'state': ['', [Validators.required]],
      'zipCode': ['', [Validators.required, Validators.maxLength(6)]],
      'sin': ['', [Validators.required, Validators.pattern(CONSTANTS.regex.sin)]],
      'confirmSin': ['', [Validators.required, compareValidator('sin')]],
      'signature': ['', [Validators.required, Validators.maxLength(100), Validators.pattern(CONSTANTS.regex.alpha)]],
      'signedOn': ['']
    });
    if ('taxInfo' in this.userData && this.userData.taxInfo) {
      this.taxForm.patchValue(this.userData.taxInfo.taxInfoT4, { onlySelf: true });
      this.taxId = this.userData.taxInfo.id;
      const sin = this.userData.taxInfo.taxInfoT4.sin;
      const newSin = sin.substring(0, 3) + '-' + sin.substring(3, 6) + '-' + sin.substring(6, 10);
      this.taxForm.patchValue({ sin: newSin });
      this.taxForm.patchValue({ confirmSin: newSin });
      this.signedOnDate = this.userData.taxInfo.taxInfoT4.signedOn;
    }
    this.taxForm.patchValue({ signedOn: this.signedOnDate });
    this.signedOnString = this.signedOnDate.split('T')[0];
  }

  // Get list of all roles for users
  getAllRoles() {
    this.profileService.getAllRoles().subscribe((_data: any) => {
    }, (err: any) => {
      this.errors = err;
    });
  }

  // checkTokenExpiry() {
  //   this.userService.checkTokenExpiry().subscribe((data) => {
  //     console.log(data);
  //   });
  // }

  // Update T4 form information
  updateTaxInfo() {
    const userData = LocalService.get('userProfile');
    const sin = (this.taxForm.get('sin') as any).value.replace(/-/g, '');
    this.taxForm.patchValue({ sin: sin });
    const taxObj = {
      id: this.taxId ? this.taxId : null,
      type: 'T4',
      taxInfoT4: this.taxForm.value,
    };
    userData.taxInfo = taxObj;
    delete userData.taxInfo.taxInfoT4.confirmSin;
    LocalService.set('userProfile', userData);
    this.router.navigate(['../'], { relativeTo: this.route });
    this.document.body.classList.add('thanks-page-body');
  }

  // Set hyphen for SIN
  setHyphen(val: any) {
    return `${val}-`;
  }

  // For checking type of a value
  checkType(value: any) {
    if (typeof (value) === 'number') {
      return true;
    }
    return false;
  }

  // Set SIN format
  setSIN(event: any, formValue: any) {
    if (event.key.length === 1) {
      const val = this.taxForm.value[formValue];
      const values = val.split('-');
      if (values.length === 1 && values[0].length === 3) {
        this.taxForm.patchValue({
          [formValue]: this.setHyphen(val)
        });
      } else if (values.length === 2 && values[1].length === 3) {
        this.taxForm.patchValue({
          [formValue]: this.setHyphen(val)
        });
      } else if (values.length === 3 && values[2].length === 3) {
        this.taxForm.patchValue({
          [formValue]: val
        });
      }
    }
  }

  ngAfterViewInit() {
    window.scrollTo(0, 0);
  }
}

